import "./TariffCard.scss";
import { useTranslation } from "../../../../../../../../../../hooks";

export const TariffCard = ({ isMonthly = true }) => {
  const { cabinet: { orders: { residential: {
    traffic, monthly, perMonth, quantity
  } } } } = useTranslation();

  return (
    <div className="tariff-card">
      <div className="tariff-card__wrapper">
        <div className="tariff-card__traffic">
          <div className="tariff-card__label">{isMonthly ? traffic : monthly}</div>
          <div className="tariff-card__value">50 GB</div>
        </div>
        <div className="tariff-card__gb">
          <div className="tariff-card__label">1 Gb </div>
          <div className="tariff-card__value">$8.50</div>
        </div>
      </div>
      <div className="tariff-card__divider"></div>
      <div className="tariff-card__price">
        <div className="tariff-card__price-value">$250</div>
        <div className="tariff-card__label">{isMonthly ? perMonth : quantity}</div>
      </div>
    </div>
  );
};
